module.exports = __webpack_public_path__ + "img/BNB.c755707d.png";